{
  "list": {
    "title": "Filters",
    "create": "Create Filter",
    "import": "Import filter",
    "loadError": "An error has occurred loading filters.",
    "statusAll": "All",
    "statusEnabled": "Enabled",
    "statusDisabled": "Disabled",
    "noStatusFilters": "No {{status}} filters",
    "noFilters": "No filters here..",
    "addNew": "Add new",
    "copied": "Filter copied to clipboard!",
    "copyFailed": "Failed to copy JSON to clipboard.",
    "fetchFailed": "Failed to get filter data.",
    "deleted": "Filter {{name}} was deleted",
    "duplicated": "Filter {{name}} duplicated",
    "updated": "{{name}} was updated successfully",
    "removeTitle": "Remove filter: {{name}}",
    "removeText": "Are you sure you want to remove this filter? This action cannot be undone.",
    "edit": "Edit",
    "exportJson": "Export JSON",
    "exportJsonDiscord": "Export JSON to Discord",
    "toggle": "Toggle",
    "duplicate": "Duplicate",
    "delete": "Delete",
    "toggleSuccess": "{{name}} was {{state}} successfully",
    "enabledState": "enabled",
    "disabledState": "disabled",
    "autoUpdatedTitle": "This filter is automatically updated by a list",
    "priority": "Priority",
    "actions": "Actions",
    "noActionsDefined": "No actions defined. Set up actions to enable snatching.",
    "noActionsEnabled": "You need to enable at least one action in the filter otherwise you will not get any snatches.",
    "downloads": "Downloads",
    "per": "per",
    "usesDisabledIndexers": "Uses disabled indexer(s): {{names}}",
    "usesDeprecatedIndexers": "Uses removed/deprecated indexer(s): {{names}}. Edit the filter to remove them or use Settings → Indexers to clean up.",
    "noIndexer": "NO INDEXER",
    "sort": {
      "label": "Sort",
      "default": "Latest",
      "nameAsc": "Name A-Z",
      "nameDesc": "Name Z-A",
      "priorityDesc": "Priority High-Low",
      "priorityAsc": "Priority Low-High",
      "createdDesc": "Recently created first",
      "createdAsc": "Recently created last",
      "updatedDesc": "Recently updated first",
      "updatedAsc": "Recently updated last"
    },
    "indexerFilter": {
      "label": "Indexer",
      "all": "All indexers"
    }
  },
  "details": {
    "tabs": {
      "general": "General",
      "moviesTv": "Movies and TV",
      "music": "Music",
      "books": "Books",
      "advanced": "Advanced",
      "external": "External",
      "actions": "Actions",
      "notifications": "Notifications",
      "new": "NEW"
    },
    "removeTitle": "Remove filter: {{name}}",
    "removeText": "Are you sure you want to remove this filter? This action cannot be undone.",
    "delete": "Delete Filter",
    "reset": "Reset form values",
    "resetSuccess": "Reset all filter values.",
    "save": "Save",
    "validationError": "Validation error",
    "validationErrors": "Validation errors",
    "mustSelectClient": "Must select client"
  },
  "importer": {
    "title": "Import filter (in JSON or autodl-irssi format)",
    "import": "Import",
    "cancel": "Cancel",
    "jsonImported": "Filter '{{name}}' imported successfully!",
    "jsonImportFailed": "Failed to import JSON data. Information logged to console.",
    "invalidFormat": "Cannot import given filter -- it is neither in JSON or autodl-irssi format.",
    "autodlImportFailed": "Failed to import autodl-irssi filter '{{name}}'. Information logged to console.",
    "autodlImportedOne": "Filter '{{name}}' imported successfully!",
    "autodlImportedMany": "All {{count}} filters imported successfully!",
    "autodlImportedPartial": "{{success}}/{{total}} filters imported successfully. See console for details.",
    "placeholder": "Paste your filter data here (either autobrr JSON format or your entire autodl-irssi config)",
    "warnings": "Import Warnings"
  },
  "general": {
    "filterName": "Filter name",
    "filterNamePlaceholder": "eg. Filter 1",
    "announceTypes": "announce types",
    "announceTypesTooltip": "NEW! Match releases which contain any of the selected announce types.",
    "indexers": "Indexers",
    "deprecatedIndexer": "{{name}} (deprecated)",
    "rulesTitle": "Rules",
    "rulesSubtitle": "Specify rules on how torrents should be handled/selected.",
    "minSize": "Min size",
    "maxSize": "Max size",
    "sizePlaceholder": "eg. 100MiB, 80GB",
    "sizeTooltip": "Supports units such as MB, MiB, GB, etc.",
    "delay": "Delay",
    "delayPlaceholder": "Number of seconds to delay actions",
    "delayTooltip": "Number of seconds to wait before running actions.",
    "priority": "Priority",
    "priorityPlaceholder": "Higher number = higher priority",
    "priorityTooltip": "Filters are checked in order of priority. Higher number = higher priority.",
    "maxDownloads": "Max downloads",
    "maxDownloadsPlaceholder": "Takes any number (0 is infinite)",
    "maxDownloadsTooltip": "Number of max downloads as specified by the respective unit.",
    "maxDownloadsPer": "Max downloads per",
    "selectUnit": "Select unit",
    "maxDownloadsPerTooltip": "The unit of time for counting the maximum downloads per filter.",
    "maxDownloadsWindowType": "Window type",
    "selectWindowType": "Select window type",
    "maxDownloadsWindowTypeTooltip": "Fixed resets the count at calendar boundaries (top of the hour, midnight, start of week). Rolling counts a sliding window of the last N units.",
    "maxDownloadsPeriod": "Every",
    "maxDownloadsPeriodTooltip": "Size of the rolling window in units. E.g. Max downloads 150 with unit DAY and every 3 allows 150 downloads within the last 3 days.",
    "skipDuplicatesProfile": "Skip Duplicates profile",
    "selectProfile": "Select profile",
    "skipDuplicatesProfileTooltip": "Select the skip duplicate profile.",
    "enabled": "Enabled",
    "enabledDescription": "Enable or disable this filter."
  },
  "actionsSection": {
    "title": "Actions",
    "subtitle": "Add to download clients or run custom commands.",
    "addNew": "Add new",
    "empty": "No actions yet!",
    "deleted": "Action {{name}} was deleted",
    "removeTitle": "Remove filter action",
    "removeText": "Are you sure you want to remove this action? This action cannot be undone.",
    "actionTitle": "Action",
    "actionSubtitle": "Define the download client for your action and its name",
    "actionType": "Action type",
    "selectType": "Select type",
    "actionTypeTooltip": "Select the action type for this action.",
    "name": "Name",
    "removeAction": "Remove Action",
    "close": "Close"
  },
  "notificationsSection": {
    "title": "Filter Notifications",
    "subtitle": "Configure which notifications should be sent for this filter. These override global notification settings.",
    "addNotification": "Add notification",
    "empty": "No filter-specific notifications configured. Global notifications will be used.",
    "selectNotification": "Select notification",
    "notificationDisabled": "Disabled for this filter",
    "serviceDisabled": "Service disabled",
    "eventsCount_one": "{{count}} event",
    "eventsCount_other": "{{count}} events",
    "removeTitle": "Remove notification",
    "removeText": "Are you sure you want to remove this notification? This action cannot be undone.",
    "notificationTitle": "Notification",
    "notificationSubtitle": "Select the notification service and events to trigger",
    "notificationService": "Notification service",
    "selectNotificationService": "Select a notification",
    "notificationServiceTooltip": "Select the notification service to use for this filter.",
    "notificationSettings": "Notification Settings",
    "disableNotification": "Disable this notification",
    "disableNotificationDesc": "Do not send events through this notification service for releases matched by this filter.",
    "notificationDisabledInfo": "This notification service is disabled for the filter. The filter still overrides global settings.",
    "triggerEvents": "Trigger events",
    "pushApproved": "Push Approved",
    "pushRejected": "Push Rejected",
    "pushError": "Push Error",
    "pushApprovedDesc": "Send notification when release is successfully sent to client",
    "pushRejectedDesc": "Send notification when release is rejected",
    "pushErrorDesc": "Send notification when an error occurs while processing",
    "removeNotification": "Remove Notification",
    "close": "Close"
  },
  "advanced": {
    "common": {
      "useRegex": "Use Regex",
      "regexTooltip1": "This field has full regex support (Golang flavour).",
      "regexTooltip2": "Remember to tick Use Regex if using more than * and ?.",
      "regexTooltip3": "Mode: (?i) case-insensitive"
    },
    "releases": {
      "title": "Release Names",
      "subtitle": "Match only certain release names and/or ignore other release names.",
      "match": "Match releases",
      "matchPlaceholder": "eg. *some?movie*,*some?show*s01*",
      "except": "Except releases",
      "exceptPlaceholder": "eg. *bad?movie*,*bad?show*s03*",
      "alert": "Ask yourself:",
      "matchWarning": "Do you have a good reason to use Match releases instead of one of the other tabs?",
      "exceptWarning": "Do you have a good reason to use Except releases instead of one of the other tabs?"
    },
    "groups": {
      "title": "Groups",
      "subtitle": "Match only certain groups and/or ignore other groups.",
      "match": "Match release groups",
      "matchPlaceholder": "eg. group1,group2",
      "matchTooltip": "Comma separated list of release groups to match.",
      "except": "Except release groups",
      "exceptPlaceholder": "eg. badgroup1,badgroup2",
      "exceptTooltip": "Comma separated list of release groups to ignore (takes priority over Match release groups)."
    },
    "categories": {
      "title": "Categories",
      "subtitle": "Match or exclude categories (if announced)",
      "match": "Match categories",
      "matchPlaceholder": "eg. *category*,category1",
      "matchTooltip": "Comma separated list of categories to match.",
      "except": "Except categories",
      "exceptPlaceholder": "eg. *category*",
      "exceptTooltip": "Comma separated list of categories to ignore (takes priority over Match categories)."
    },
    "tags": {
      "title": "Tags",
      "subtitle": "Match or exclude tags (if announced)",
      "match": "Match tags",
      "matchPlaceholder": "eg. tag1,tag2",
      "matchTooltip": "Comma separated list of tags to match.",
      "matchLogic": "Match logic",
      "matchLogicDefault": "any",
      "matchLogicTooltip": "Logic used to match filter tags.",
      "except": "Except tags",
      "exceptPlaceholder": "eg. tag1,tag2",
      "exceptTooltip": "Comma separated list of tags to ignore (takes priority over Match tags).",
      "exceptLogic": "Except logic",
      "exceptLogicDefault": "any",
      "exceptLogicTooltip": "Logic used to match except tags."
    },
    "uploaders": {
      "title": "Uploaders",
      "subtitle": "Match or ignore uploaders (if announced)",
      "match": "Match uploaders",
      "matchPlaceholder": "eg. uploader1,uploader2",
      "matchTooltip": "Comma separated list of uploaders to match.",
      "except": "Except uploaders",
      "exceptPlaceholder": "eg. anonymous1,anonymous2",
      "exceptTooltip": "Comma separated list of uploaders to ignore (takes priority over Match uploaders)."
    },
    "language": {
      "title": "Language",
      "subtitle": "Match or ignore languages (if announced)",
      "match": "Match Language",
      "except": "Except Language"
    },
    "origins": {
      "title": "Origins",
      "subtitle": "Match Internals, Scene, P2P, etc. (if announced)",
      "match": "Match Origins",
      "except": "Except Origins"
    },
    "freeleech": {
      "title": "Freeleech",
      "subtitle": "Match based off freeleech (if announced)",
      "percent": "Freeleech percent",
      "percentPlaceholder": "eg. 50,75-100",
      "percentTooltip1": "Freeleech may be announced as a binary true/false value or as a percentage, depending on the indexer. Use one or the other.",
      "percentTooltip2": "The Freeleech toggle overrides this field if it is toggled/true.",
      "percentTooltip3": "Refer to our documentation for more details:",
      "toggle": "Freeleech",
      "toggleDescription": "Cannot be used with Freeleech percent. Overrides Freeleech percent if toggled/true.",
      "toggleTooltip1": "Freeleech may be announced as a binary true/false value or as a percentage, depending on the indexer. Use one or the other.",
      "toggleTooltip2": "This field overrides Freeleech percent if it is toggled/true.",
      "toggleTooltip3": "See who uses what in the documentation:"
    },
    "feedSpecific": {
      "title": "RSS/Torznab/Newznab-specific",
      "subtitle": "These options are only for Feeds such as RSS, Torznab and Newznab",
      "matchDescription": "Match description",
      "matchDescriptionPlaceholder": "eg. *some?movie*,*some?show*s01*",
      "exceptDescription": "Except description",
      "exceptDescriptionPlaceholder": "eg. *bad?movie*,*bad?show*s03*",
      "minSeeders": "Min Seeders",
      "maxSeeders": "Max Seeders",
      "minLeechers": "Min Leechers",
      "maxLeechers": "Max Leechers",
      "countPlaceholder": "Takes any number (0 is infinite)",
      "seedersTooltip": "Number of {{type}} as specified by the respective unit. Only for Torznab"
    },
    "rawReleaseTags": {
      "title": "Raw Release Tags",
      "subtitlePrefix": "Advanced users only",
      "subtitleSuffix": "This is the raw releaseTags string from the announce.",
      "warning": "These might not be what you think they are. For very advanced users who know how things are parsed.",
      "match": "Match release tags",
      "except": "Except release tags",
      "placeholder": "eg. *mkv*,*foreign*"
    }
  },
  "moviesTv": {
    "title": "Movies / Shows",
    "placeholder": "eg. Movie,Show 1,Show?2",
    "wildcardTooltip": "You can use basic filtering like wildcards * or replace single characters with ?",
    "years": "Years",
    "yearsPlaceholder": "eg. 2018,2019-2021",
    "yearsTooltip": "This field takes a range of years and/or comma separated single years.",
    "seasonEpisode": {
      "title": "Seasons, Episodes and Date",
      "subtitle": "Set season, episode, year, months and day match constraints.",
      "seasons": "Seasons",
      "seasonsPlaceholder": "eg. 1,3,2-6",
      "seasonsTooltip": "See docs for information about how to only grab season packs:",
      "episodes": "Episodes",
      "episodesPlaceholder": "eg. 2,4,10-20",
      "episodesTooltip": "See docs for information about how to only grab episodes:",
      "dailyShows": "Daily Shows",
      "months": "Months",
      "monthsPlaceholder": "eg. 4,2-9",
      "monthsTooltip": "This field takes a range of months and/or comma separated single months.",
      "days": "Days",
      "daysPlaceholder": "eg. 1,15-30",
      "daysTooltip": "This field takes a range of days and/or comma separated single days.",
      "smartEpisode": "Smart Episode",
      "smartEpisodeDescription": "Do not match episodes older than the last one matched."
    },
    "quality": {
      "title": "Quality",
      "subtitle": "Set resolution, source, codec and related match constraints.",
      "resolutions": "Resolutions",
      "resolutionsTooltip": "Will match releases which contain any of the selected resolutions.",
      "sources": "Sources",
      "sourcesTooltip": "Will match releases which contain any of the selected sources.",
      "codecs": "Codecs",
      "codecsTooltip": "Will match releases which contain any of the selected codecs.",
      "containers": "Containers",
      "containersTooltip": "Will match releases which contain any of the selected containers.",
      "matchHdr": "Match HDR",
      "matchHdrTooltip": "Will match releases which contain any of the selected HDR designations.",
      "exceptHdr": "Except HDR",
      "exceptHdrTooltip": "Won't match releases which contain any of the selected HDR designations (takes priority over Match HDR).",
      "matchOther": "Match Other",
      "matchOtherTooltip": "Will match releases which contain any of the selected designations.",
      "exceptOther": "Except Other",
      "exceptOtherTooltip": "Won't match releases which contain any of the selected Other designations (takes priority over Match Other)."
    }
  },
  "music": {
    "artists": "Artists",
    "artistsPlaceholder": "eg. Artist One",
    "albums": "Albums",
    "albumsPlaceholder": "eg. That Album",
    "wildcardTooltip": "You can use basic filtering like wildcards * or replace single characters with ?",
    "matchRecordLabels": "Match record labels",
    "matchRecordLabelsPlaceholder": "eg. Anjunabeats, Armada",
    "matchRecordLabelsTooltip": "Comma separated list of record labels to match. Only Orpheus and Redacted support this.",
    "exceptRecordLabels": "Except record labels",
    "exceptRecordLabelsPlaceholder": "eg. Anjunadeep, Armind",
    "exceptRecordLabelsTooltip": "Comma separated list of record labels to ignore (takes priority over Match record labels). Only Orpheus and Redacted support this.",
    "releaseDetails": {
      "title": "Release details",
      "subtitle": "Type (Album, Single, EP, etc.) and year of release (if announced)",
      "musicType": "Music Type",
      "musicTypeTooltip": "Will only match releases with any of the selected types.",
      "years": "Years",
      "yearsPlaceholder": "eg. 2018,2019-2021",
      "yearsTooltip": "This field takes a range of years and/or comma separated single years."
    },
    "quality": {
      "title": "Quality",
      "subtitle": "Format, source, log, etc.",
      "format": "Format",
      "formatTooltip": "Will only match releases with any of the selected formats. This is overridden by Perfect FLAC.",
      "quality": "Quality",
      "qualityTooltip": "Will only match releases with any of the selected qualities. This is overridden by Perfect FLAC.",
      "media": "Media",
      "mediaTooltip": "Will only match releases with any of the selected sources. This is overridden by Perfect FLAC.",
      "cue": "Cue",
      "cueDescription": "Must include CUE info",
      "log": "Log",
      "logDescription": "Must include LOG info",
      "logScore": "Log score",
      "logScorePlaceholder": "eg. 100",
      "logScoreTooltip": "Log scores go from 0 to 100. This is overridden by Perfect FLAC.",
      "or": "OR",
      "perfectFlac": "Perfect FLAC",
      "perfectFlacDescription": "Override all options about quality, source, format, and cue/log/log score.",
      "perfectFlacTooltip": "Override all options about quality, source, format, and CUE/LOG/LOG score.",
      "perfectFlacHint": "This is what you want in 90% of cases (instead of options above)."
    }
  },
  "books": {
    "authors": "Authors",
    "authorsPlaceholder": "eg. Author One",
    "titles": "Titles",
    "titlesPlaceholder": "eg. That Book",
    "wildcardTooltip": "You can use basic filtering like wildcards * or replace single characters with ?",
    "years": "Years",
    "yearsPlaceholder": "eg. 2018,2019-2021",
    "yearsTooltip": "This field takes a range of years and/or comma separated single years.",
    "options": {
      "title": "Options",
      "subtitle": "Language, format, and tags",
      "matchLanguage": "Match Language",
      "exceptLanguage": "Except Language",
      "format": "Format",
      "formatTooltip": "Will only match releases with any of the selected formats.",
      "matchTags": "Match tags",
      "matchTagsPlaceholder": "eg. tag1,tag2",
      "matchTagsTooltip": "Comma separated list of tags to match.",
      "exceptTags": "Except tags",
      "exceptTagsPlaceholder": "eg. tag1,tag2",
      "exceptTagsTooltip": "Comma separated list of tags to ignore (takes priority over Match tags)."
    }
  },
  "external": {
    "title": "External filters",
    "subtitle": "Run external scripts or webhooks and check status as part of filtering.",
    "addNew": "Add new",
    "empty": "No external filters yet!",
    "removeTitle": "Remove external filter",
    "removeText": "Are you sure you want to remove this external filter? This action cannot be undone.",
    "sectionTitle": "External Filter",
    "sectionSubtitle": "Define the type of your filter and its name",
    "type": "Type",
    "name": "Name",
    "onError": "On Error",
    "selectType": "Select type",
    "typeTooltip": "Select the type for this external filter.",
    "onErrorTooltip": "Select what to do on error for this external filter.",
    "remove": "Remove External",
    "close": "Close",
    "types": {
      "EXEC": "Exec",
      "WEBHOOK": "Webhook"
    },
    "onErrorOptions": {
      "REJECT": "Reject",
      "CONTINUE": "Continue to next"
    },
    "execute": {
      "title": "Execute",
      "subtitle": "Specify the executable, the argument and the expected exit status to run as a pre-filter",
      "path": "Path to Executable",
      "pathPlaceholder": "Absolute path to executable eg. /bin/test",
      "pathTooltip": "For custom commands you should specify the full path to the binary/program you want to run. And you can include your own static variables:",
      "args": "Exec Arguments",
      "argsPlaceholder": "Arguments eg. --test \"{{ .TorrentName }}\"",
      "expectedExitStatus": "Expected exit status"
    },
    "request": {
      "title": "Request",
      "subtitle": "Specify your request destination endpoint, headers and expected return status",
      "endpoint": "Endpoint",
      "endpointPlaceholder": "Host eg. http://localhost/webhook",
      "endpointTooltip": "URL or IP to your API. Pass params and set API tokens etc.",
      "httpMethod": "HTTP method",
      "httpMethodDefault": "Select http method",
      "httpMethodTooltip": "Select the HTTP method for this webhook. Defaults to POST",
      "headers": "HTTP Request Headers",
      "headersPlaceholder": "HEADER=custom1,HEADER2=custom2",
      "expectedStatus": "Expected HTTP status code"
    },
    "retry": {
      "title": "Retry",
      "subtitle": "Retry behavior on request failure",
      "retryStatus": "Retry http status code(s)",
      "retryStatusPlaceholder": "Retry on status eg. 202, 204",
      "retryAttempts": "Maximum retry attempts",
      "retryDelaySeconds": "Retry delay in seconds"
    },
    "payload": {
      "title": "Payload",
      "subtitle": "Specify your JSON payload",
      "data": "Data (json)",
      "dataPlaceholder": "Request data: { \"key\": \"value\" }"
    }
  },
  "actionComponents": {
    "instance": {
      "title": "Instance",
      "subtitle": "Select the specific instance which you want to handle this release filter."
    },
    "common": {
      "category": "Category",
      "categoryPlaceholder": "eg. category",
      "categoryTooltip": "Category must exist already.",
      "savePath": "Save path",
      "savePathPlaceholder": "eg. /full/path/to/download_folder",
      "numberNoLimit": "Takes any number (0 is no limit)",
      "limitsTitle": "Limits",
      "limitsSubtitle": "Configure your speed/ratio/seed time limits",
      "limitDownloadKib": "Limit download speed (KiB/s)",
      "limitUploadKib": "Limit upload speed (KiB/s)",
      "limitDownloadKb": "Limit download speed (KB/s)",
      "limitUploadKb": "Limit upload speed (KB/s)",
      "ratioLimit": "Ratio limit",
      "seedTimeMinutes": "Seed time limit (minutes)",
      "addPaused": "Add paused",
      "addPausedDescription": "Add torrent as paused",
      "skipHashCheck": "Skip hash check",
      "skipHashCheckDescription": "Add torrent and skip hash check",
      "announceTitle": "Announce",
      "announceSubtitle": "Set number of reannounces (if needed), delete after Y announce failures, etc.",
      "disableReannounce": "Disable reannounce",
      "disableReannounceDescription": "Reannounce is enabled by default. Disable if it's not needed",
      "reannounceInterval": "Reannounce interval. Run every X seconds",
      "reannounceIntervalPlaceholder": "7 is default and recommended",
      "deleteStalled": "Delete stalled",
      "deleteStalledDescription": "Delete stalled torrents after Y attempts",
      "reannounceMaxAttempts": "Run reannounce Y times"
    },
    "test": {
      "alert": "Heads up!",
      "text": "The test action does nothing except to show if the filter works. Make sure to have your Logs page open while testing."
    },
    "exec": {
      "title": "Exec Arguments",
      "subtitle": "Specify the executable and its arguments to be executed upon filter match. Use an absolute path.",
      "path": "Path to Executable",
      "pathPlaceholder": "Path to program eg. /bin/test",
      "arguments": "Arguments",
      "argumentsPlaceholder": "Arguments eg. --test"
    },
    "watchFolder": {
      "title": "Watch Folder Arguments",
      "subtitle": "Point to where autobrr should save the files it fetches. Use an absolute path.",
      "directory": "Watch directory",
      "directoryPlaceholder": "Watch directory eg. /home/user/rwatch"
    },
    "webhook": {
      "title": "Webhook Arguments",
      "subtitle": "Specify the payload to be sent to the desired endpoint upon filter match.",
      "endpoint": "Endpoint",
      "endpointPlaceholder": "Host eg. http://localhost/webhook",
      "endpointTooltip": "URL or IP to your API. Pass params and set API tokens etc.",
      "payload": "Payload (json)",
      "payloadPlaceholder": "Request data: { \"key\": \"value\" }"
    },
    "arr": {
      "overrideClientName": "Override download client name for arr",
      "overrideClientNameTooltip": "Override download client name from the one set in Clients. Useful if you have multiple clients inside the arr.",
      "overrideClientId": "Override download client id for arr DEPRECATED",
      "overrideClientIdTooltip": "Override download client ID from the one set in Clients. Useful if you have multiple clients inside the arr."
    },
    "qbittorrent": {
      "macrosTooltip": "The field can use macros to transform/add values from metadata:",
      "tags": "Tags",
      "tagsPlaceholder": "eg. tag1,tag2",
      "savePathPlaceholder": "eg. /full/path/to/save_folder",
      "savePathTooltip": "Set a custom save path for this action. Automatic Torrent Management will take care of this if using qBittorrent with categories.",
      "downloadPath": "Download path",
      "downloadPathPlaceholder": "eg. /full/path/to/download_folder",
      "downloadPathTooltip": "Set a custom download (incomplete) path for this action. Automatic Torrent Management will take care of this if using qBittorrent with categories.",
      "rulesTitle": "Rules",
      "rulesSubtitle": "Configure your torrent client rules",
      "ignoreRules": "Ignore existing client rules",
      "ignoreRulesDescription": "Choose to ignore rules set in Client Settings.",
      "contentLayout": "Content Layout",
      "contentLayoutDefault": "Select content layout",
      "priority": "Priority",
      "priorityDefault": "Disabled",
      "priorityTooltip": "Torrent Queueing will be enabled for you if it is disabled. Ensure you set your preferred limits for it in your client.",
      "firstLastPiece": "Download first and last pieces first",
      "firstLastPieceDescription": "Add torrent and download first and last pieces first"
    },
    "deluge": {
      "label": "Label",
      "labelPlaceholder": "eg. label1 (must exist in Deluge to work)",
      "skipHashCheckTooltip": "This will only work on Deluge v2."
    },
    "transmission": {
      "label": "Torrent Label(s)",
      "labelPlaceholder": "eg. label1,label2"
    },
    "rtorrent": {
      "label": "Label",
      "labelPlaceholder": "eg. label1,label2",
      "renameToPath": "Do not add torrent name to path",
      "renameDefault": "No"
    },
    "porla": {
      "preset": "Preset",
      "presetPlaceholder": "eg. default",
      "presetTooltip": "A case-sensitive preset name as configured in Porla.",
      "savePathPlaceholder": "eg. /full/path/to/torrent/data"
    }
  },
  "addForm": {
    "title": "Create filter",
    "subtitle": "Add new filter.",
    "closePanel": "Close panel",
    "name": "Name",
    "required": "Required",
    "cancel": "Cancel",
    "create": "Create",
    "added": "Filter {{name}} was added"
  }
}
